module.exports = __webpack_public_path__ + "static/img/About-video.b411e0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/About/img/About-video.jpg
// module id = 517
// module chunks = 0